import React, { useState, useEffect, useRef } from 'react'
import api from '../lib/api'

export default function ServiceTitleAutocomplete({ value, onChange, className, placeholder, required }) {
  const [serviceTypes, setServiceTypes] = useState([])
  const [filtered, setFiltered] = useState([])
  const [open, setOpen] = useState(false)
  const [highlightIndex, setHighlightIndex] = useState(-1)
  const wrapperRef = useRef(null)

  useEffect(() => {
    api.get('/service_types').then((res) => setServiceTypes(res.data))
  }, [])

  useEffect(() => {
    if (value) {
      const lower = value.toLowerCase()
      setFiltered(serviceTypes.filter((st) => st.name.toLowerCase().includes(lower)))
    } else {
      setFiltered(serviceTypes)
    }
    setHighlightIndex(-1)
  }, [value, serviceTypes])

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleSelect = (name) => {
    onChange({ target: { name: 'title', value: name } })
    setOpen(false)
  }

  const handleKeyDown = (e) => {
    if (!open || filtered.length === 0) return

    if (e.key === 'ArrowDown') {
      e.preventDefault()
      setHighlightIndex((prev) => (prev < filtered.length - 1 ? prev + 1 : 0))
    } else if (e.key === 'ArrowUp') {
      e.preventDefault()
      setHighlightIndex((prev) => (prev > 0 ? prev - 1 : filtered.length - 1))
    } else if (e.key === 'Enter' && highlightIndex >= 0) {
      e.preventDefault()
      handleSelect(filtered[highlightIndex].name)
    } else if (e.key === 'Escape') {
      setOpen(false)
    }
  }

  return (
    <div ref={wrapperRef} className="relative">
      <input
        name="title"
        value={value}
        onChange={(e) => {
          onChange(e)
          setOpen(true)
        }}
        onFocus={() => setOpen(true)}
        onKeyDown={handleKeyDown}
        required={required}
        className={className}
        placeholder={placeholder}
        autoComplete="off"
      />
      {open && filtered.length > 0 && (
        <ul className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg max-h-48 overflow-y-auto">
          {filtered.map((st, i) => (
            <li
              key={st.id}
              onMouseDown={() => handleSelect(st.name)}
              className={`px-3 py-2 text-sm cursor-pointer ${
                i === highlightIndex ? 'bg-surface text-accent' : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              {st.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
